var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, action, computed } from "mobx";
import { InternalMessageBusChannels } from "sb-internal-msg-bus";
export class AggregatesScoresBlockState {
    constructor(provider) {
        this.provider = provider;
        this.scores = {};
        this.currentIncident = {};
        this.previousIncident = {};
        this.shouldSlideDown = false;
        this.animationConfiguration = {
            timeout: {},
            duration: 3000,
            style: ""
        };
        this.clearAnimation = this.clearAnimation.bind(this);
    }
    activate() {
        this.provider.on(InternalMessageBusChannels.aggregatedEvents.incident.update, this.updateLatestIncident);
        this.provider.on(InternalMessageBusChannels.aggregatedEvents.scores.update, this.updateScores);
        this.provider.emit(InternalMessageBusChannels.aggregatedEvents.incident.request);
        this.provider.emit(InternalMessageBusChannels.aggregatedEvents.scores.request);
    }
    deactivate() {
        this.provider.off(InternalMessageBusChannels.aggregatedEvents.incident.update, this.updateLatestIncident);
        this.provider.off(InternalMessageBusChannels.aggregatedEvents.scores.update, this.updateScores);
        this.clearData();
    }
    updateLatestIncident(message) {
        if (message.data[0] && message.data[0].incidents[0]) {
            if (message.data[0].incidents[0].id !== this.currentIncident.id) {
                this.previousIncident = this.currentIncident;
                this.previousIncident.id && this.startAnimation();
            }
            this.currentIncident = message.data[0].incidents[0];
        }
    }
    updateScores(message) {
        if (message.data[0] && message.data[0].scores) {
            this.scores = message.data[0].scores;
        }
    }
    startAnimation() {
        clearTimeout(this.animationConfiguration.timeout);
        this.animationConfiguration.style = "rj-incident-item-slide-down-and-blink-animation";
        this.animationConfiguration.timeout = setTimeout(this.clearAnimation, this.animationConfiguration.duration);
    }
    clearAnimation() {
        this.removeAnimationClass();
        this.resetPreviousIncident();
    }
    removeAnimationClass() {
        this.animationConfiguration.style = "";
    }
    resetPreviousIncident() {
        this.previousIncident = {};
    }
    clearData() {
        this.currentIncident = {};
        this.scores = {};
        this.shouldSlideDown = false;
    }
    get areScoresLoaded() {
        return this.scores && this.scores.participant1data !== undefined;
    }
    get hasCurrentIncident() {
        return this.currentIncident && this.currentIncident.id !== undefined;
    }
    toggleShouldSlideDown() {
        this.shouldSlideDown = !this.shouldSlideDown;
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], AggregatesScoresBlockState.prototype, "currentIncident", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AggregatesScoresBlockState.prototype, "previousIncident", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AggregatesScoresBlockState.prototype, "scores", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], AggregatesScoresBlockState.prototype, "shouldSlideDown", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AggregatesScoresBlockState.prototype, "updateLatestIncident", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AggregatesScoresBlockState.prototype, "updateScores", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AggregatesScoresBlockState.prototype, "startAnimation", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AggregatesScoresBlockState.prototype, "removeAnimationClass", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AggregatesScoresBlockState.prototype, "resetPreviousIncident", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AggregatesScoresBlockState.prototype, "clearData", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AggregatesScoresBlockState.prototype, "areScoresLoaded", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AggregatesScoresBlockState.prototype, "hasCurrentIncident", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AggregatesScoresBlockState.prototype, "toggleShouldSlideDown", null);
//# sourceMappingURL=AggregatesScoresBlockState.js.map